import { paragraphs } from '@iheartjane/menu';
import { Typography } from '@iheartjane/reefer';

interface MultiParagraphProps {
  children: string;
}

export const MultiParagraph = ({ children }: MultiParagraphProps) => {
  return (
    <Typography as="div" color="text-main">
      {paragraphs(children)}
    </Typography>
  );
};
